import { render, staticRenderFns } from "./AssignBusinessAccountManagerModal.vue?vue&type=template&id=b3f72912"
import script from "./AssignBusinessAccountManagerModal.vue?vue&type=script&lang=js"
export * from "./AssignBusinessAccountManagerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports